import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import GenerateAvatar from "../../../shared/components/GenerateAvatar";
import {
  capitalizeFirst,
  monthStringFormatDate,
} from "../../../utils/extensions";
import Dropdown from "../../../shared/components/Dropdown";
import { createStyles, makeStyles } from "@mui/styles";
import { updateReportById } from "../../../services/component";
import { toastError, toastSuccess } from "../../../utils/ToastMessage";

type Props = {
  data: any;
};

const ReportCard = (props: Props) => {
  const styles = useStyles();
  const [status, setStatus] = useState<string>("");

  const handleUpdateReportStatus = async (value: any) => {
    await updateReportById(
      {
        status: value,
      },
      props.data?._id
    )
      .then((res: any) => {
        if (res?.success) {
          setStatus(res?.data?.status);
          toastSuccess("Successfully updated!", "Status updated successfully.");
        }
      })
      .catch((err: any) => {
        console.error(err);
        toastError("Something went wrong.", "Failed to update feedback.");
      });
  };

  useEffect(() => {
    if (props?.data?.status) {
      setStatus(capitalizeFirst(props?.data?.status));
    }
  }, [props?.data?.status]);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        borderRadius: "14px",
        bgcolor: "#141414",
        padding: "24px 31px 24px 24px",
        gap: "16px",
      }}
    >
      {/* -------Header Section------- */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "24px",
        }}
      >
        {/* ----Profile Section---- */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          {props?.data?.userId?.avatar ? (
            <img
              style={{
                width: "60px",
                height: "60px",
                aspectRatio: "1/1",
                borderRadius: "50%",
                objectFit: "cover",
              }}
              alt="profile"
              src={props?.data?.userId?.avatar || ""}
            />
          ) : (
            <GenerateAvatar
              width="60px"
              height="60px"
              text={
                props?.data?.userId?.firstName
                  ? props?.data?.userId?.lastName
                    ? props?.data?.userId?.firstName[0].toUpperCase() +
                      props?.data?.userId?.lastName[0].toUpperCase()
                    : props?.data?.userId?.firstName[0].toUpperCase()
                  : "UN"
              }
            />
          )}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              // gap: "6px",
              textAlign: "start",
            }}
          >
            <Typography
              sx={{
                fontWeight: "600",
                color: "white",
              }}
              variant="body1"
            >
              {`${
                props?.data?.userId?.firstName
                  ? capitalizeFirst(props?.data?.userId?.firstName)
                  : ""
              } ${
                props?.data?.userId?.lastName
                  ? capitalizeFirst(props?.data?.userId?.lastName)
                  : ""
              } 
              `}
            </Typography>
            <Typography
              sx={{
                mb: "6px",
                fontWeight: "400",
                color: "rgba(255, 255, 255, 0.5)",
              }}
              variant="body2"
            >
              {props?.data?.userId?.email}
            </Typography>
            <Typography
              sx={{
                color: "rgba(255, 255, 255, 0.5)",
              }}
              variant="body2"
            >
              Report filed on {monthStringFormatDate(props?.data?.createdAt)}
            </Typography>
          </Box>
        </Box>

        {/* ----Report Status---- */}
        <Box>
          <Dropdown
            className={styles.dropdown}
            classDropdownPlaceholder={styles.placeholder}
            classDropdownValueText={styles.dropdownValueText}
            dropdownOptionsBodyStyles={{
              fontWeight: "300",
              fontSize: "16px",
            }}
            dropdownBodyStyles={{
              width: "150px",
            }}
            value={status}
            placeholder="Select"
            setValue={handleUpdateReportStatus}
            options={["Open", "In Progress", "Resolved", "Irrelevant"]}
          />
        </Box>
      </Box>

      {/* -----Report Description----- */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          textAlign: "start",
          gap: "12px",
        }}
      >
        <Typography
          sx={{
            fontWeight: "600",
            color: "white",
            lineHeight: "100%",
          }}
          variant="body1"
        >
          {props?.data?.title}
        </Typography>
        <Typography
          sx={{
            color: "rgba(255, 255, 255, 0.5)",
            lineHeight: "100%",
          }}
          variant="body2"
        >
          {" "}
          {props?.data?.description}
        </Typography>
      </Box>
    </Box>
  );
};

export default ReportCard;

const useStyles = makeStyles(() =>
  createStyles({
    dropdown: {
      width: "100%",
      minWidth: "132px",
      maxWidth: "132px",
      height: "46px",
    },
    placeholder: {
      color: "#A0AEC0",
      fontSize: "16px",
      fontWeight: "300 !important",
      fontFamily: "Outfit",
    },
    dropdownValueText: {
      color: "white",
      fontSize: "16px",
      fontWeight: "300",
    },
  })
);
